import * as React from 'react';
import * as styles from './styles.css';
import { ITextListCell } from '../../../../../../types/newbuildingsCompare';
import { Body1 } from '@cian/ui-kit';
import clsx from 'clsx';

export interface ITextListCellProps {
  cell: ITextListCell;
  isInfrastructureBlock: boolean;
}

export const TextListCell = ({ cell, isInfrastructureBlock }: ITextListCellProps): React.JSX.Element => (
  <div className={clsx(isInfrastructureBlock && styles['container-infrastructure'], styles['container'])}>
    {cell.data?.items && cell.data.items.map((item, index) => <Body1 key={index}>{item}</Body1>)}
  </div>
);
